import { useQuery } from "@tanstack/react-query";
import { getAirportById } from "../../api/apiAirports";

const useGetAirport = (id) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ["airport", id],
        queryFn: () => getAirportById(id),
        enabled: !!id,
    });

    return {
        airport: data?.data || null,
        isLoading,
        error,
    };
};

export default useGetAirport;
